<template>
  <b-modal
    title="Wybierz węzeł nadrzędny"
    v-model="showModal"
    ok-title="Zapisz"
    cancel-title="Anuluj"
    ok-variant="outline-primary"
    cancel-variant="outline-secondary"
    @ok.prevent="addTreeStruct"
    @hidden="$emit('cancel')"
  >
    <v-jstree :data="items" :async="loadData" show-checkbox whole-row @item-click="itemClick"></v-jstree>
  </b-modal>
</template>

<script>
import VJstree from 'vue-jstree';
import { LogicalStructureResource } from '@/resources/logicalStructure.resource';

export default {
  components: {
    VJstree
  },
  props: {
    show: Boolean,
    item: Object
  },
  data() {
    return {
      nodeId: null,
      showModal: false,
      items: [],
      disabledNodes: []
    };
  },
  methods: {
    itemClick(node) {
      this.nodeId = node.model.id;
    },
    async addTreeStruct() {
      try {
        const selectedTreeStruct = await LogicalStructureResource.changeParent(this.item.id, this.nodeId, this.item.parentId);
        this.$notify({ type: 'success', text: 'Pomyślnie zmieniono węzeł nadrzędny', title: 'Sukces' });
        this.$emit('tree', selectedTreeStruct, this.item.parentId);
      } catch (error) {
        this.$notify({ type: 'error', text: 'Wystąpił błąd podczas zmiany węzła nadrzędnego', title: 'Błąd' });
      }
    },
    async loadData(selectedNode, resolve) {
      try {
        const logicalStructure = await (selectedNode.data && selectedNode.data.id ? LogicalStructureResource.children(selectedNode.data.id) : LogicalStructureResource.fullList());
        const treeData = logicalStructure.map(item => {
          const dParent = this.disabledNodes.find(e => e === item.parentId);
          const disabled = this.item && (item.id === this.item.id || dParent);
          if (disabled) {
            this.disabledNodes.push(item.id);
          }
          return { id: item.id, text: item.name, isLeaf: !item.hasChildren, disabled, selected: this.item && item.id === this.item.parentId };
        });
        resolve(treeData);
      } catch (error) {
        this.$notify({ type: 'error', title: 'Błąd', text: error.message });
      }
    }
  },
  beforeMount() {
    this.showModal = this.show;
  }
};
</script>

<style></style>
